import { writable } from 'svelte/store';
import type { mujoco as Mujoco } from 'mujoco_wasm_contrib/debug';
import type { Group, Light } from 'three';

/**
 * Stores for MuJoCo objects to be shared across components
 */

// Core MuJoCo instances
export const mujocoInstance = writable<Mujoco | null>(null);

// Scene and model data
export const mujocoModel = writable<Mujoco['Model'] | null>(null);
export const mujocoSimulation = writable<Mujoco['Simulation'] | null>(null);
export const mujocoState = writable<Mujoco['State'] | null>(null);

// Three.js objects
export const mujocoBodies = writable<Record<number, Group> | null>(null);
export const mujocoLights = writable<Light[] | null>(null);

// Scene management
export const scenes = writable<Record<string, string>>({});
export const selectedScene = writable<string | null>(null);

// Simulation loading progress (wasm runtime + scene assets)
export interface SimLoadingProgress {
	active: boolean;
	percent: number;
	label: string;
}
export const simLoadingProgress = writable<SimLoadingProgress>({
	active: false,
	percent: 0,
	label: ''
});

/**
 * Helper function to clear all MuJoCo stores
 */
export function clearMujocoStores(): void {
	mujocoModel.set(null);
	mujocoSimulation.set(null);
	mujocoState.set(null);
	mujocoBodies.set(null);
	mujocoLights.set(null);
}
